// Global placement defaults for every Vuetify dropdown.
//
// Vuetify 2 has no defaults API (that arrived in v3), so the only way to change a prop
// default app-wide is to overwrite it on the registered component. Two details make this
// safe rather than a hack:
//
// 1. `VSelect.$_menuProps` merges instead of replacing — `{ ...defaultMenuProps, ...ours }`
//    (vuetify/lib/components/VSelect/VSelect.js). Overriding the `menuProps` default
//    therefore changes only the keys named below; `closeOnClick`, `disableKeys`,
//    `maxHeight` and friends still apply.
// 2. The app uses Vuetify's full `dist` build (the package's `main` *and* `module` both
//    point at `dist/vuetify.js`), and `Vue.use(Vuetify)` registers every component through
//    `Vue.component()`. So the live constructors live in `Vue.options.components` —
//    importing from `vuetify/lib` here would mutate a different copy of Vuetify and
//    silently do nothing.
//
// Called from `./vuetify` immediately after `Vue.use(Vuetify)`, which runs at module-eval
// time, so the defaults are in place before anything renders.

import Vue from 'vue'

// Gap in pixels between a field and the menu it opens.
export const MENU_OFFSET = 8

export default function applyVuetifyDefaults () {
  const { VSelect, VAutocomplete, VCombobox, VOverflowBtn, VMenu } = Vue.options.components

  // Without `offsetY` a select's menu is positioned at the activator's own top, i.e. it
  // covers the field. `VAutocomplete` already sets it, but only earns a 1px gap.
  const selectLike = [VSelect, VAutocomplete, VCombobox, VOverflowBtn]

  selectLike.filter(Boolean).forEach((component) => {
    component.options.props.menuProps.default = () => ({
      offsetY: true,
      nudgeBottom: MENU_OFFSET
    })
  })

  // Only the gap for standalone `v-menu`: it is also used for attached and anchored popups,
  // so forcing every one below its activator would reach far beyond dropdowns. Call sites
  // that want the dropdown behaviour keep their explicit `offset-y`.
  if (VMenu) {
    VMenu.options.props.nudgeBottom.default = MENU_OFFSET
  }
}
